import { routes } from "../../../router";
import { action, computed, observable } from "mobx";
import ViewModel from "../../../infrastructure/ViewModel";
import RouteList from "../../../infrastructure/RouteList";
import ProducerStore from "../../../store/ProducerStore";
import { AgentAppointmentsViewModel } from "./../../../viewModels/agents/AgentAppointmentsViewModel";
import ContractsStore from "../../../store/ContractsStore";
import Utils from "../../../infrastructure/Utils";
import {
  ActiveCarrierList,
  RtsCertificationModel,
} from "../../../services/ContractService";
import axios from "axios";
import PageContext from "../../../infrastructure/PageContext";
import Collection from "../../../infrastructure/CollectionHelper";
import { RTSProductTypes } from "../../../infrastructure/enum/Common";

export class ManageRTSV2ViewModel implements ViewModel {
  get CanClose(): boolean {
    throw new Error("Method not implemented.");
  }
  get CanRoute(): boolean {
    return true;
  }
  get IsLoaded(): boolean {
    throw new Error("Method not implemented.");
  }
  get IsLoading(): boolean {
    throw new Error("Method not implemented.");
  }
  Close(): void {
    throw new Error("Method not implemented.");
  }
  Route = async (currentRoute: RouteList): Promise<void> => {};

  @observable gridApi: any;
  @observable gridApiData: any;
  @observable rtsData: any = [];
  @observable rtsAttestationData: any = [];
  @observable rtsLifeData: any = [];
  @observable agentId: number = 0;
  @observable agentNPN: string = "";
  @observable pageIndex: number = 0;
  @observable pageSize: number = 50;
  @observable skip: number = 0;
  @observable take: number = 10;
  @observable sortColumn: string = "npn";
  @observable sortAscending: boolean = true;
  @observable fullTextFilter: string = "";
  @observable filterList: any;
  @observable selectedUser: string = "";
  @observable isEditVisible: boolean = true;
  @observable isCancelVisible: boolean = false;
  @observable AgentAppointmentsViewModel: AgentAppointmentsViewModel =
    new AgentAppointmentsViewModel();
  @observable selectedKey: string | undefined = "";
  @observable selectedTabIndex?: number = 0;
  @observable selectedPanel: string = "Automated";

  @observable isDeleteModalVisible: boolean = false;
  @observable deleteRowData: any;
  @observable rtsToken: string = "";
  @observable rtsUrl: string = "";
  @observable finalExpensesUrl: string = "";
  @observable isDeleteClicked: boolean = false;
  @observable paginatorId: string = "paginator" + Math.random();

  @action Load = async (agentId: any, npn: string) => {
    this.isLifeMasterCarrierLoaded = false;
    this.isDeleteClicked = false;
    this.agentId = agentId;
    this.agentNPN = npn;
    this.resetData();
    if (this.agentNPN) {
      await this.getRTSToken();
      await this.getStateList();
      this.getActiveContractCarriers();
      Utils.listenScrollEvent(PageContext.updateHorizontalScrollBar);
      this.getData();
    }
  };

  @action resetData = () => {
    this.selectedTabIndex = 0;
    this.selectedPanel = "Automated";
    localStorage.setItem("rtsReviewAgent", "");
    this.gridApiData = [];
    this.rtsData = [];
    this.rtsAttestationData = [];
    this.rtsLifeData = [];
    this.lifeMasterCarrierList = [];
    this.lifeContractCarrierList = [];
  };

  @observable healthContractCarrierList: ActiveCarrierList[] = [];
  @observable lifeContractCarrierList: ActiveCarrierList[] = [];

  @action getRTSToken = async () => {
    let rtsData = await ContractsStore.getManageRtsToken();
    this.rtsToken = rtsData.access_token || "";
    this.rtsUrl = rtsData.url || "";
    this.finalExpensesUrl = rtsData.finalExpensesUrl || "";
  };

  @action getActiveContractCarriers = async () => {
    let result = await ContractsStore.getActiveContractCarriers(this.agentNPN);
    this.healthContractCarrierList = result.healthCarrierList || [];
    this.lifeContractCarrierList = result.lifeCarrierList || [];
  };

  @computed get getTabIndex(): number {
    let tabIndex = 0;
    switch (this.selectedKey) {
      case "Manual":
        tabIndex = 0;
        break;
      case "Automated":
        tabIndex = 1;
        break;
      default:
        tabIndex = 0;
        break;
    }
    return tabIndex;
  }

  @action setDeleteConfirmModel = (value: boolean) => {
    this.isDeleteModalVisible = value;
  };

  @action deleteRtsDataConfirm = (value: any) => {
    this.deleteRowData = value;
    this.setDeleteConfirmModel(true);
  };

  @action deleteRtsData = async (agentName: string) => {
    try {
      this.isDeleteClicked = true;
      if (this.deleteRowData.productType == this.lifeProductTypeLabel) {
        let carrierData = this.rtsLifeData.filter((i: any) => {
          return i.fexAttestationId == this.deleteRowData.fexAttestationId;
        });

        let productCategoryId = 0,
          naic = "",
          supplierId = 0;

        if (carrierData && carrierData.length > 0) {
          naic = carrierData[0].naic;
          supplierId = carrierData[0].supplierId;
          productCategoryId = carrierData[0].productCategory.id;
        }

        let request = {
          agentNPN: this.agentNPN,
          naic: naic,
          supplierId: supplierId,
          productCategoryId: productCategoryId,
          inActive: 1,
        };

        const urlAttestation = this.rtsUrl + "/fexAttestation/" + this.agentNPN;
        await axios.put(`${urlAttestation}`, request, {
          headers: this.getHeaders(),
        });
      } else {
        const urlAttestation =
          this.rtsUrl +
          "/attestation/" +
          this.agentNPN +
          "/" +
          this.deleteRowData.attestationId;
        await axios.delete(`${urlAttestation}`, { headers: this.getHeaders() });
      }
      this.setDeleteConfirmModel(false);
      Utils.showSuccessToaster(
        "The attestation request for " +
          (agentName.includes("(") ? agentName.split("(")[0] : "") +
          " has been deleted",
        4000
      );
      this.getData();
      this.discardChanges();
      this.isLifeMasterCarrierLoaded = false;
      this.isDeleteClicked = false;
    } catch (error: any) {
      this.isDeleteClicked = false;
      Utils.showWarningToaster(error.response.data, 4000);
    }
  };

  @action handleTabClick = (index: number | undefined, key: string): void => {
    this.selectedTabIndex = index;
    this.setSelectedPanel(key);
  };

  @action setSelectedPanel = async (value: string) => {
    this.selectedPanel = value;
    if (value == "Manual") {
      this.callAppointments();
    } else {
    }
  };

  @action callAppointments = (): void => {
    this.AgentAppointmentsViewModel.load(this.agentId);
  };

  @action getHeaders = () => {
    let headers = {
      "Content-Type": "application/json",
      Accept: "text/plain",
      authorization: this.rtsToken,
    };
    return headers;
  };

  @observable addAttestationLookupModel: any = [];

  @action getData = async () => {
    const url = this.rtsUrl + "/Agents/rts/" + this.agentNPN;
    const urlAttestation = this.rtsUrl + "/attestation/" + this.agentNPN;
    const lifeRTSUrl = this.rtsUrl + "/fexAttestation/" + this.agentNPN;
    PageContext.isLoading = true;

    try {
      let res = await axios.get(`${url}`, { headers: this.getHeaders() });
      this.rtsData = res.data;
    } catch (error) {}
    try {
      let attestation = await axios.get(`${urlAttestation}`, {
        headers: this.getHeaders(),
      });
      this.rtsAttestationData = attestation.data;
    } catch (error: any) {
      Utils.showWarningToaster(error.response.data, 4000);
    }

    try {
      let rtsLife = await axios.get(`${lifeRTSUrl}`, {
        headers: this.getHeaders(),
      });
      this.rtsLifeData = rtsLife.data;
    } catch (error) {}
    PageContext.isLoading = false;

    this.gridApiData = [];
    if (this.rtsLifeData && this.rtsLifeData.length > 0) {
      this.rtsLifeData = this.rtsLifeData.filter(
        (i: any) => i.productCategory.name == "Final Expense"
      );
      this.rtsLifeData.forEach((i: any) => {
        var lifeData = {
          attestationId: 0,
          fexAttestationId: i.fexAttestationId,
          agentId: 0,
          bu: "",
          npn: i.agentNPN,
          carrier: i.displayCarrierName,
          awn: i.writingNumber,
          tin: "",
          state: "",
          planType: i.productCategory && i.productCategory.name,
          producerId: i.producerId,
          status: i.isSelfAttested ? "Admin Attested" : "",
          planYear: "",
          blobPath: "",
          isSelfAttested: false,
          inActive: 0,
          createDate: i.createDate,
          lastUpdated: null,
          isExpired: i.isExpired,
          attestationPlatform: i.attestationPlatform,
          productType: this.lifeProductTypeLabel,
        };
        this.gridApiData.push(lifeData);
      });
    }

    let result = [];
    if (this.rtsData && this.rtsData.length > 0) {
      this.rtsData = this.rtsData.map((i: any) => {
        i.status = i.status == "Y" ? "Yes" : i.status == "N" ? "No" : i.status;
        i.productType = RTSProductTypes.Health;
        return i;
      });

      let helper: any = {};
      result = this.rtsData.reduce(function (r: any, o: any) {
        let key =
          o.carrier +
          "-" +
          o.producerId +
          "-" +
          o.planType +
          "-" +
          o.planYear +
          "-" +
          o.businessUnit +
          "-" +
          o.blobPath;
        if (!helper[key]) {
          helper[key] = Object.assign({}, o);
          r.push(helper[key]);
        } else {
          if (helper[key].state && helper[key].state.indexOf(o.state) === -1) {
            helper[key].state += ", " + o.state;
          }
        }
        return r;
      }, []);
      this.createAddAttestationLookupModel(result);
    }

    if (this.rtsAttestationData && this.rtsAttestationData.length > 0) {
      this.rtsAttestationData = this.rtsAttestationData.map((i: any) => {
        i.producerId = i.awn;
        i.businessUnit = i.bu;
        i.planType = i.product;
        i.status = i.rtsStatus
          ? i.rtsStatus == "Y"
            ? "Yes"
            : i.rtsStatus == "N"
            ? "No"
            : i.rtsStatus
          : "Admin Attested";
        i.isSelfAttested = i.isSelfAttested ? "TRUE" : "FALSE";
        i.productType = RTSProductTypes.Health;
        return i;
      });
    }

    let resultData = [...result, ...this.rtsAttestationData];
    this.gridApiData = [...this.gridApiData, ...resultData];

    PageContext.updateHorizontalScrollBar();
  };

  @action onRowsPerPage = async (value: number) => {
    let recordCount = this.gridApi.paginationGetRowCount();
    let len = this.pageIndex * value;
    if (len >= recordCount) {
      this.pageIndex = 0;
    }
    this.pageSize = value;
  };

  onPaginationChanged = async (params: any = null, pageIndex: number) => {
    this.pageIndex = pageIndex;
    this.gridApi.paginationGoToPage(pageIndex);
  };

  @action rtsReview = async (agentName: string) => {
    await this.setSelectedAgentName();
    localStorage.setItem("rtsReviewAgent", "" + this.agentId + "^" + agentName);
    routes.rtsReview.push();
  };

  @action download = async () => {
    this.gridApi.exportDataAsExcel();
  };

  @action setSelectedAgentName = async () => {
    try {
      if (this.agentId != null && this.agentId != undefined) {
        var agentInfo = await ProducerStore.getAgentProfileInfoById(
          this.agentId
        );
        if (agentInfo && agentInfo.name) {
          let nameArray = agentInfo.name.split(" ");
          if (nameArray.length > 1) {
            this.selectedUser = nameArray[1] + ", " + nameArray[0];
          } else {
            this.selectedUser = nameArray[0];
          }
        }
      }
    } catch (e) {}
  };

  @observable awn: string = "";
  @observable stateTempList: string[] = [];
  @observable carrierGroupList: string[] = [];
  @observable lifeMasterCarrierList: any = [];
  @observable isLifeMasterCarrierLoaded: boolean = false;
  @observable lifeProductTypeLabel = RTSProductTypes.Life;

  @action getCarrierData = async (productType: string) => {
    let carrierList: any = [];
    let rowNode = this.gridApi.getPinnedTopRow(0);

    if (productType == RTSProductTypes.Life) {
      carrierList = await this.setLifeDependantFields(carrierList, rowNode);
    } else if (productType == RTSProductTypes.Health) {
      carrierList = this.setHealthDependantFields(carrierList, rowNode);
    }
    rowNode.data.carrierList = [...["Select Carrier Group"], ...carrierList];
    rowNode.data.producerId = "";
    rowNode.data.state = "";
    this.refreshPinnedRow(rowNode);
  };

  @action getLookups = async (carrier: string, productType: string) => {
    let rowNode = this.gridApi.getPinnedTopRow(0);
    rowNode.data.producerId = "";
    rowNode.data.state = "";

    if (productType == RTSProductTypes.Life) {
      let selectedCarrier = this.lifeContractCarrierList.filter((i: any) => {
        return i.carrierName.toLowerCase() == carrier.toLowerCase();
      });

      if (selectedCarrier && selectedCarrier.length > 0) {
        rowNode.data.awnList = [
          ...["Select Writing Number"],
          ...new Set(
            selectedCarrier[0].writingNumbers &&
              selectedCarrier[0].writingNumbers.map((i: any) => {
                return i;
              })
          ),
        ];
      }
    } else if (productType == RTSProductTypes.Health) {
      rowNode.data.planType = "";
      this.setHealthCarrierDependantLookup(carrier, rowNode);
    }
    this.refreshPinnedRow(rowNode);
  };

  @observable stateList = new Collection<any>();
  @action getStateList = async () => {
    let result = await ContractsStore.appointmentStates();
    if (result != null) {
      this.stateList.values = [];
      if (result) {
        for (let item of result) {
          if (!item.isHeader) this.stateList.values.push(item.abbreviation);
        }
      }
    }
  };
  private getStateLookup = (carrier: string, product: string) => {
    let existingStates = [
      ...new Set(
        this.rtsAttestationData
          .filter((i: any) => {
            return (
              i.carrier.toLowerCase() == carrier.toLowerCase() &&
              i.product == product
            );
          })
          .map((i: any) => {
            return i.state;
          })
          .sort()
      ),
    ];

    let stateList = this.stateList.values.filter((i) => {
      return !existingStates.includes(i);
    });

    return stateList;
  };

  @action getStatesByProduct = (carrier: string, product: string) => {
    let rowNode = this.gridApi.getPinnedTopRow(0);
    //let stateList = this.getStateLookup(carrier, product);

    rowNode.data.stateList = [...["Select State"], ...this.stateList.values];
    this.refreshPinnedRow(rowNode);
  };

  @action addAttestation = async () => {
    let editRows = this.gridApiData.filter((i: any) => i.edit);
    if (editRows.length == 0) {
      this.awn = "";
      let productList = [];
      let stateList = [];
      let planYearList = [];
      productList.push("Select Product");
      stateList.push("Select State");
      planYearList.push("Select Plan Year");
      planYearList.push(new Date().getFullYear() + "");
      planYearList.push(new Date().getFullYear() + 1 + "");

      let rtsData = {
        agentId: this.agentId,
        npn: this.agentNPN,
        carrier: "",
        awn: "",
        state: "",
        status: "",
        planYear: "",
        planType: "",
        certificationDate: "",
        attestedDate: Utils.getDateInFormat(new Date()),
        appointmentDate: "",
        source: "",
        edit: true,
        carrierList: ["Select Carrier Group"],
        productList: productList,
        stateList: stateList,
        planYearList: planYearList,
        awnList: ["Select Writing Number"],
      };
      this.gridApi.setPinnedTopRowData([rtsData]);
      let rowNode = this.gridApi.getPinnedTopRow(0);
      this.refreshPinnedRow(rowNode);
    }
  };
  @action refreshPinnedRow = (rowNode: any) => {
    const params = {
      force: true,
      rowNodes: [rowNode],
    };
    setTimeout(() => {
      this.gridApi.refreshCells(params);
    }, 0);
  };

  @action findChangeDetection = (rowData: any) => {
    let isValid = false;
    if (
      (rowData.productType == RTSProductTypes.Health &&
        rowData.carrier != "" &&
        rowData.carrier != "Select Carrier Group" &&
        rowData.producerId != "" &&
        rowData.producerId != "Select Writing Number" &&
        rowData.planType != "" &&
        rowData.planType != "Select Product" &&
        rowData.state != "" &&
        rowData.state != "Select State" &&
        rowData.planYear != "" &&
        rowData.planYear != "Select Plan Year") ||
      (rowData.productType == RTSProductTypes.Life &&
        rowData.carrier != "" &&
        rowData.carrier != "Select Carrier Group" &&
        rowData.producerId != "" &&
        rowData.producerId != "Select Writing Number" &&
        rowData.planType != "" &&
        rowData.planType != "Select Product")
    )
      isValid = true;

    let isChangeDetected = false;
    if (
      rowData.productType == RTSProductTypes.Health &&
      ((rowData.carrier != "" && rowData.carrier != "Select Carrier Group") ||
        rowData.producerId != "" ||
        (rowData.planType != "" && rowData.planType != "Select Product") ||
        (rowData.state != "" && rowData.state != "Select State") ||
        (rowData.planYear != "" && rowData.planYear != "Select Plan Year"))
    )
      isChangeDetected = true;
    else if (
      rowData.productType == RTSProductTypes.Life &&
      ((rowData.carrier != "" && rowData.carrier != "Select Carrier Group") ||
        rowData.producerId != "" ||
        (rowData.planType != "" && rowData.planType != "Select Product"))
    )
      isChangeDetected = true;

    let action = rowData.action ? true : false;
    let rowNode = this.gridApi.getPinnedTopRow(0);
    rowNode.data.action = !action;
    rowNode.data.isChangeDetected = isChangeDetected;
    rowNode.data.isValid = isValid;
    this.refreshPinnedRow(rowNode);
  };

  @action saveAttestation = async (rowData: any, agentName: string) => {
    PageContext.isLoading = true;
    try {
      let rtsData = {
        carrierGroup: rowData.carrier,
        npn: rowData.npn,
        awn: rowData.producerId ? rowData.producerId : this.awn,
        state: rowData.state,
        product: rowData.planType,
        planYear: rowData.planYear || 0,
        productType: rowData.productType,
      } as RtsCertificationModel;
      ContractsStore.addRtsCertification(rtsData);
    } catch (error: any) {}
    try {
      if (rowData.isValid) {
        let rowNode = this.gridApi.getPinnedTopRow(0);
        rowNode.data.isValid = false;
        this.refreshPinnedRow(rowNode);

        if (rowData.productType == this.lifeProductTypeLabel) {
          let carrierData = this.lifeMasterCarrierList.filter((i: any) => {
            return i.displayCarrierName == rowData.carrier;
          });

          let productCategoryId = 0,
            carrierName = "",
            displayCarrierName = "",
            carrierId = 0,
            naic = "",
            supplierId = 0;

          if (carrierData && carrierData.length > 0) {
            carrierName = carrierData[0].carrierName;
            displayCarrierName = carrierData[0].displayCarrierName;
            carrierId = carrierData[0].carrierId;
            naic = carrierData[0].naic;
            supplierId = carrierData[0].supplierId;
            let productCategory = carrierData[0].productCategories.filter(
              (i: any) => {
                return i.name == rowData.planType;
              }
            );

            if (productCategory && productCategory.length > 0) {
              productCategoryId = productCategory[0].id;
            }
          }

          let request = {
            agentNPN: this.agentNPN,
            carrierName: carrierName,
            displayCarrierName: displayCarrierName,
            carrierId: carrierId,
            naic: naic,
            supplierId: supplierId,
            productNames: [],
            producerId: rowData.producerId,
            isSelfAttested: "Yes",
            inActive: 0,
            carrierAppointmentDate: undefined,
            buContractDate: undefined,
            buName: Utils.getBUName().substring(0, 3),
            productCategoryId: productCategoryId,
            attestationPlatform: "Agency or Business Unit",
          };

          this.isLifeMasterCarrierLoaded = false;
          const urlAttestation =
            this.rtsUrl + "/fexAttestation/" + this.agentNPN;
          await axios.post(`${urlAttestation}`, request, {
            headers: this.getHeaders(),
          });

          Utils.showSuccessToaster(
            (agentName.includes("(") ? agentName.split("(")[0] : "") +
              " can access quoting tools.",
            4000
          );
        } else {
          let data = this.rtsData.filter((i: any) => {
            return (
              i.carrier == rowData.carrier &&
              i.producerId == rowData.producerId &&
              i.planType == rowData.planType &&
              i.planYear == rowData.planYear
            );
          });
          let blobPath = data && data.length > 0 ? data[0].blobPath : "";

          let rtsDataAttestation = {
            agentRts: {
              awn: rowData.producerId,
              bu: Utils.getRtsBUName(),
              selfAttestationDate: new Date(),
              isSelfAttested: true,
              blobPath: blobPath,
              rtS_STATUS: "",
              attestationPlatform: "Agency or Business Unit",
            },
            selfAttestationRequests: [
              {
                carrier: rowData.carrier,
                planYear: rowData.planYear,
                states: [rowData.state],
                planType: rowData.planType,
                tin: "",
                agentProducerID: rowData.producerId,
                snpTypes: [],
                stateExpirationDate: undefined,
              },
            ],
          };
          const urlAttestation = this.rtsUrl + "/attestation/" + this.agentNPN;
          await axios.post(`${urlAttestation}`, rtsDataAttestation, {
            headers: this.getHeaders(),
          });

          Utils.showSuccessToaster(
            (agentName.includes("(") ? agentName.split("(")[0] : "") +
              " can access quoting tools. This request expires in 7 days.",
            4000
          );
        }

        this.gridApi.setPinnedTopRowData([]);
        this.getData();
      }
    } catch (error: any) {
      Utils.showWarningToaster(error.response.data, 4000);

      setTimeout(() => {
        let rowNode = this.gridApi.getPinnedTopRow(0);
        rowNode.data.isValid = true;
        this.refreshPinnedRow(rowNode);
      }, 2000);
    }
    PageContext.isLoading = false;
  };

  @action discardChanges = async () => {
    this.gridApi.setPinnedTopRowData([]);
  };

  @action setGridApi = async (api: any) => {
    this.gridApi = api;
  };

  private setHealthCarrierDependantLookup(carrier: string, rowNode: any) {
    let productList = [],
      planYearList = [],
      stateList = [];
    let attestationLookups = this.addAttestationLookupModel.filter(
      (i: any) => i.carrier == carrier.toLowerCase()
    );

    if (attestationLookups && attestationLookups.length > 0) {
      this.awn = attestationLookups[0].awn;
      stateList = attestationLookups[0].stateList;
      productList = attestationLookups[0].productList;
      planYearList = attestationLookups[0].planYearList;
    }

    let selectedCarrier = this.healthContractCarrierList.filter((i: any) => {
      return i.carrierName.toLowerCase() == carrier.toLowerCase();
    });

    if (selectedCarrier && selectedCarrier.length > 0) {
      rowNode.data.awnList = [
        ...["Select Writing Number"],
        ...new Set(
          selectedCarrier[0].writingNumbers &&
            selectedCarrier[0].writingNumbers.map((i: any) => {
              return i;
            })
        ),
      ];
      rowNode.data.productList = [
        ...["Select Product"],
        ...new Set(
          selectedCarrier[0].productTypes &&
            selectedCarrier[0].productTypes.filter((i: any) => {
              return productList.indexOf(i) > -1;
            })
        ),
      ];

      rowNode.data.stateList = [...["Select State"], ...this.stateList.values];
      rowNode.data.producerId = "";
      rowNode.data.state = "";
      rowNode.data.planYearList = [...["Select Plan Year"], ...planYearList];
    }
  }

  private setHealthDependantFields(carrierList: any, rowNode: any) {
    let healthContractCarriers = this.healthContractCarrierList.map(
      (i: ActiveCarrierList) => i.carrierName || ""
    );

    carrierList = healthContractCarriers.filter((i: any) => {
      return this.carrierGroupList.indexOf(i.trim().toLowerCase()) > -1;
    });
    rowNode.data.planYear = new Date().getFullYear() + "";
    rowNode.data.productList = ["Select Product"];
    rowNode.data.planType = "";
    return carrierList;
  }

  private async setLifeDependantFields(carrierList: any, rowNode: any) {
    if (!this.isLifeMasterCarrierLoaded) {
      const url = this.finalExpensesUrl + "/selfattest/carriers";
      let headers = {
        "Content-Type": "application/json",
        Accept: "text/plain",
        authorization: this.rtsToken,
        AgentNPN: this.agentNPN,
      };

      try {
        let res = await axios.get(`${url}`, { headers: headers });
        this.lifeMasterCarrierList = res.data;
        this.isLifeMasterCarrierLoaded = true;
      } catch (error) {}
    }

    let lifeCarriers = this.lifeMasterCarrierList
      .filter(
        (i: any) =>
          i.productCategories.filter((j: any) => j.name == "Final Expense")
            .length > 0
      )
      .map((i: any) => i.displayCarrierName.toLowerCase());

    let lifeContractCarriers = this.lifeContractCarrierList.map(
      (i: ActiveCarrierList) => i.carrierName || ""
    );

    carrierList = lifeContractCarriers.filter((i) => {
      return lifeCarriers.indexOf(i.trim().toLowerCase()) > -1;
    });
    rowNode.data.productList = ["Select Product", "Final Expense"];
    rowNode.data.planType = "Final Expense";
    rowNode.data.planYear = "";
    return carrierList;
  }

  private createAddAttestationLookupModel(rtsData: any) {
    let sellingCarrierList: any = [];
    rtsData.forEach((element: any) => {
      let states = this.getStateLookup(element.carrier, element.planType);
      if (states && states.length > 0) {
        element.stateList = states;
        sellingCarrierList.push(element);
      }
    });

    let carrierList = sellingCarrierList
      .map((i: any) => {
        return i.carrier && i.carrier.toLowerCase();
      })
      .sort();
    this.carrierGroupList = [...new Set(carrierList)] as string[];
    this.addAttestationLookupModel = [];

    carrierList.forEach((carrier: string) => {
      let data = sellingCarrierList.filter(
        (i: any) => i.carrier.toLowerCase() == carrier
      );
      let attestation = {
        carrier: carrier,
        awn: data && data.length > 0 ? data[0].producerId : "",
        productList: sellingCarrierList
          .filter((i: any) => i.carrier.toLowerCase() == carrier)
          .map((i: any) => {
            return i.planType;
          })
          .sort(),
        planYearList: [
          ...[],
          ...new Set(
            [
              ...sellingCarrierList
                .filter((i: any) => i.carrier.toLowerCase() == carrier)
                .map((i: any) => {
                  return i.planYear + "";
                }),
              ...[
                new Date().getFullYear() + "",
                new Date().getFullYear() + 1 + "",
              ],
            ].sort()
          ),
        ],
      };
      this.addAttestationLookupModel.push(attestation);
    });
  }
  @action onFilterChanged = (params: any) => {
    this.paginatorId = "paginator" + Math.random();
  };
}
